import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

@Component({
  selector: 'app-report-app',
  templateUrl: './report-app.component.html',
  styleUrls: ['./report-app.component.css'],
   providers: [HelperService] 
})
export class ReportAppComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
 from;
 to;
 datas:any=[];
 dtOptions: DataTables.Settings = {};
 dtTrigger: Subject<any> = new Subject();
  dtElement: DataTableDirective;
 start_date ;
 end_date;
date = new FormControl(new Date());
 from_date;
 to_date;
 user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  
 constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router) {
  	
  		activatedRouter.queryParams.subscribe(params => {
    this.from = params['from'];
    this.to = params['to'];

    if(this.from!=0){
       this.start_date  = new Date(Date.parse(this.from));
      
     this.end_date = new Date(Date.parse(this.to));
     
    }
});
     
  	
  }


  ngOnInit() {
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/report?type=app&from='+this.from+'&to='+this.to,{ headers: this.headers })
      
      .subscribe(data => {
        this.datas = JSON.parse(data['_body']);
        
          this.dtTrigger.next();
        
       
      });
  }
  startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
  
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


   if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
      this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   this.router.navigate(['reports/appUsers'], { queryParams: { from: start_date,to: end_date } }));
     
    }
   }
   
  }
  endEvent(type: string, event: MatDatepickerInputEvent<Date>) {
 
   let d1 = new Date(Date.parse(this.start_date));
   let start_date = d1.getFullYear()+"-"+(d1.getMonth()+1)+"-"+d1.getDate();

   let d2 = new Date(Date.parse(this.end_date));
   let end_date = d2.getFullYear()+"-"+(d2.getMonth()+1)+"-"+d2.getDate();


    if(end_date!="NaN-NaN-NaN" && start_date!="NaN-NaN-NaN"){
    let sDate = new Date(start_date);
    let eDate = new Date(end_date);

    if(sDate<=eDate){
        this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
   this.router.navigate(['reports/appUsers'], { queryParams: { from: start_date,to: end_date } }));
    }


   }
 
  }

}



// WEBPACK FOOTER //
// ./src/app/report-app/report-app.component.ts